import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { experimentsClient } from '#pplx_generated/typespec/rest/experiments/client.js';
/**
 * Get user attributes for experiments and feature flagging.
 * These attributes are used for personalization and determining feature eligibility.
 *
 * @param args.reason - The reason for fetching the attributes (for logging purposes)
 * @param args.headers - Optional additional headers to include in the request
 * @returns The experiment attributes from the server, or null if there's an error
 */
export const getExperimentsAttributes = async ({ reason, headers = {}, }) => {
    try {
        const { data, error } = await experimentsClient.GET('/rest/experiments/attributes', reason, {
            headers,
            timeoutMs: getQueryTimeoutMs({ productionMs: 2000 }),
            numRetries: 1,
        });
        if (error) {
            logger.error('Failed to fetch experiment attributes', {
                error,
                reason,
            });
            return null;
        }
        return (data ?? null);
    }
    catch (err) {
        logger.error('Error fetching experiment attributes', {
            error: err,
            reason,
        });
        return null;
    }
};
//# sourceMappingURL=getExperimentsAttributes.js.map